import initializer from './initializer'

window.angularModules = [];

(function ($) {
  $(document).ready(() => {
    initializer(document)
  })
}(jQuery))
